import PropTypes from 'prop-types'

export const CentreType = PropTypes.shape({
  slug: PropTypes.string.isRequired,
  sys: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }).isRequired,
})
